export const GENRES = [
  "Contemporary Fiction",
  "Historical Fiction",
  "Romance",
  "Mystery & Thriller",
  "Literary Fiction",
  "Fantasy",
  "Science Fiction",
  "Memoir & Biography",
  "Personal Development",
  "Poetry",
  "African American Literature",
  "Spirituality & Faith",
  "History & Culture",
  "Business & Entrepreneurship",
  "Other",
];
